export const WITHOUT_MENTORSHIP_POINTS = [
    ["Unstructured Learning", "Trial & Error"],
    ["Slow Progress", "Knowledge Gaps"],
    ["Low Confidence", "Weak Problem-Solving"],
    ["Job Readiness Issues", "Lack of Support"],
];

export const WITH_MENTORSHIP_POINTS = [
    ["Structured Learning", "Faster Growth"],
    ["Instant Feedback", "Real-World Exposure"],
    ["Stronger Confidence", "Better Decision-Making"],
    ["Higher Success Rate", "1:1 Guidance"],
];
